import { render, staticRenderFns } from "./approver.vue?vue&type=template&id=54eb68b4&scoped=true"
import script from "./approver.vue?vue&type=script&lang=js"
export * from "./approver.vue?vue&type=script&lang=js"
import style0 from "./approver.vue?vue&type=style&index=0&id=54eb68b4&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54eb68b4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\xc\\integrated-business-and-finance-wechat\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('54eb68b4')) {
      api.createRecord('54eb68b4', component.options)
    } else {
      api.reload('54eb68b4', component.options)
    }
    module.hot.accept("./approver.vue?vue&type=template&id=54eb68b4&scoped=true", function () {
      api.rerender('54eb68b4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/flow/approver.vue"
export default component.exports